import React from 'react';
import styled from 'styled-components';

import Icon from 'kingpin/atoms/Icon';

// The class the row's :hover rule reveals (see CompositeCard)
export const ROW_HANDLE_CLASS = 'studio-row-handle';

// Centred on the row's left side, a tall pill over its outline (inside the
// block's edge, which clips it, for a divided row that runs to the edge).
// Over everything else there (ROW_HANDLE_Z_INDEX): its cells' resize handles
// and menus, the row's resize handle, and the block's own resize handles
// along its edge (see StudioCanvas), which it would otherwise sit under.
const ROW_HANDLE_Z_INDEX = 20;
const Handle = styled.div<{ $left: number; $isDraggable: boolean }>`
  position: absolute;
  top: 50%;
  left: ${(props) => props.$left}px;
  z-index: ${ROW_HANDLE_Z_INDEX};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 24px;
  transform: translateY(-50%);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  background-color: var(--color-bg-primary);
  box-shadow: var(--shadow-dropdown);
  color: var(--color-icon-secondary);
  cursor: ${(props) => (props.$isDraggable ? 'grab' : 'pointer')};

  &:hover {
    color: var(--color-text-primary);
  }
`;

// A row's own handle, for the row itself rather than its cells: pressed, it
// selects the row (see CompositeCard's Row); dragged, it moves it among the
// block's rows, as the row's own space does (the row is what's dragged).
// The only way to the row where its cells leave none of its own (a divided
// row runs them edge to edge).
const RowHandle = ({
  rowId,
  left,
  isDraggable,
}: {
  rowId: string;
  left: number;
  isDraggable: boolean;
}) => (
  <Handle
    className={ROW_HANDLE_CLASS}
    $left={left}
    $isDraggable={isDraggable}
    title={
      isDraggable
        ? 'Drag to move the row, or click to select it'
        : 'Select the row'
    }
    data-testid={`studio-composite-row-handle-${rowId}`}
  >
    <Icon icon="drag" width={12} height={12} color="currentColor" />
  </Handle>
);

export default RowHandle;
